


















































































































































































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {snakeCase} from 'lodash'
import {$, PageCollection, ID, MixinUpload, success, error, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import FilterDriver from '@/components/filters/FilterDriver.vue'
import {Role} from '@/enums/Role'
import Motorista from '@/model/resource/Motorista'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import ModalMotoristaEdit from '@/components/modals/ModalEditMotorista.vue'
import DriverRequest from '@/model/request/DriverRequest'
import ModalSimple from '@/components/modals/ModalSimple.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import * as Helper from '@/helpers'
import {FileObject} from 'image-compressor.js'
import ModalDriverPassword from '@/components/modals/ModalDriverPassword.vue'

const metaInfo = () => ({
  title: $.t('view.manage.driverList.title'),
})

@Component({
  metaInfo,
  components: {ModalDriverPassword, FilterToggle, ModalSimple, FilterDriver, ModalMotoristaEdit},
})
export default class ManageDriverListView extends Mixins(MixinFilter, MixinSelect, MixinUpload) {
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('auth/role') role!: Role

  Role = Role
  AppConfig = AppConfig
  Helper = Helper
  pushByName = pushByName

  filter = new DriverRequest()

  collection = new PageCollection(Motorista, {}, 10)
  selectedItems: Motorista[] = []
  selecting = false // notify only selected or notify all
  notifyOpen = false
  notifyMessage = ''
  motoristaToRemove: Motorista | null = null

  @Watch('files')
  async filesEvent(filesObject: FileObject[]) {
    if (!filesObject.length) return

    $.await.init('persistMotorista')

    const files = filesObject.map((item) => item.file)
    try {
      await Helper.cadastrarMotoristas(files)
      this.$emit('success')
    } catch (e) {
      this.$emit('fail')
    } finally {
      this.files = []
      $.await.done('persistMotorista')
    }
  }

  async closeDelete() {
    this.motoristaToRemove = null
    await this.query()
  }

  motoristaNotifyList() {
    this.selecting = true
    this.notifyOpen = true
  }

  motoristaNotifyAll() {
    this.selecting = false
    this.notifyOpen = true
    this.selectedResource = {}
  }

  cancelNotify() {
    this.selecting = false
    this.notifyOpen = false
    this.selectedResource = {}
  }

  async sendMessages() {
    let driverIds: ID[] = []
    if (this.selecting) {
      if (!this.selectedItems.length) {
        error('view.manage.driverList.noDriverSelected')
        return
      }
      driverIds = this.selectedItems.map((driver) => {
        return driver.$id
      })
    }
    await Motorista.notifyMotoristas(this.notifyMessage, driverIds, !this.selecting)
    success('view.manage.driverList.successOnNotify')
    this.cancelNotify()
  }

  async removeDriver() {
    if (!this.motoristaToRemove) {
      return
    }

    await this.motoristaToRemove.removeMotorista(this.motoristaToRemove.idMotoristaPk)
    await this.collection.search()
    this.motoristaToRemove = null
  }

  async downloadData(xlsx = false) {

      if (!xlsx) {
      const csv = new PageCollection(Motorista, this.filter, null, null)

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')

      csv.items.forEach((item) => {
        const { tipoVeiculoData, tipoVeiculo } = item;
        item.tipoVeiculoFk = tipoVeiculoData.nome !== "" ? tipoVeiculoData.nome : tipoVeiculo;
      });
      csv.downloadCsv(snakeCase($.t('classes.Motorista.title')))
    } else {
      await $.await.run(() => Helper.downloadXlsx(
        $.t('classes.Motorista.title'),
        new Motorista().$endpoint,
        this.filter,
        Motorista,
        'Motorista',
      ), 'download')
    }
  }

  openModalDriverPassword(motorista: Motorista) {
    this.$modal.open('modalDriverPassword', motorista)
  }
}
